/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import FilenameToastCss from "./FilenameToast.css";
import classNames from "classnames";
import { Toast } from "@react/react-spectrum/Toast";
import { toastHideManager } from "utils/ComponentHideManager";
import * as stores from "stores";
import { isCurrentDeviceMobile, isCurrentDeviceTablet } from "dc-preview-utils/src/Utils/DeviceUtils";
import { FILENAME_TOAST_MAX_WIDTH, FILENAME_TOAST_BORDER_WIDTH } from "constants/constants";

class FilenameToast extends Component {
  constructor(props) {
    super(props);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.setIsMouseOverToast = this.setIsMouseOverToast.bind(this);
  }

  handleMouseEnter(evt) {
    this.setIsMouseOverToast(true);
  }

  handleMouseLeave(evt) {
    this.setIsMouseOverToast(false);
    toastHideManager.resurfaceToast(stores);
  }

  setIsMouseOverToast(status) {
    stores.documentStore.setIsMouseOverToast(status);
  }

  // onMouseOver should be accompanied by onFocus for accessibility reasons as mentioned in ESLint
  onFocus() {}

  render() {
    let toastStyle = {
      backgroundColor: "var(--spectrum-global-color-gray-100)",
      color: "var(--spectrum-global-color-gray-800)",
      maxWidth: `${FILENAME_TOAST_MAX_WIDTH - 2 * FILENAME_TOAST_BORDER_WIDTH}px`,
      padding: "8px 16px"
    };
    let rootStyle = {
      border: `${FILENAME_TOAST_BORDER_WIDTH}px solid rgba(44, 44, 44, 0.14)`
    };
    let className = FilenameToastCss.ToastView;
    if (!this.props.shouldAutoHideToast || this.props.isMouseOverToast) {
      className = classNames(className, FilenameToastCss.showToast);
    } else {
      className = classNames(className, FilenameToastCss.hideToast);
      this.setIsMouseOverToast(false);
    }

    const shouldBindMouseEvents = !isCurrentDeviceMobile() && !isCurrentDeviceTablet();

    return (
      <div
        className={className}
        style={rootStyle}
        onMouseEnter={shouldBindMouseEvents ? this.handleMouseEnter : null}
        onFocus={shouldBindMouseEvents ? this.onFocus : null}
        onMouseLeave={shouldBindMouseEvents ? this.handleMouseLeave : null}
      >
        <Toast timeout={0} style={toastStyle}>
          <div className={FilenameToastCss.toastContent}>
            <span className={FilenameToastCss.fileName}>{this.props.fileName}</span>
            <span className={FilenameToastCss.extension}>{this.props.fileExtension}</span>
          </div>
        </Toast>
      </div>
    );
  }
}

export { FilenameToast };
